import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Header,
  Modal,
  SpaceBetween,
} from "@amzn/awsui-components-react/polaris";

/**
 * Per-deliverable "Row Settings" dialog opened from the admin gear in the
 * Deliverable column. Shows only the first tab's content (Actions):
 *   - Options: Show Self Certify
 *   - Reset: Reset Statuses
 *   - Notifications: digest / duplicate-upload opt-outs
 *
 * Backendless for now: Save simply hands the assembled settings back to the
 * caller and closes. Wire onSave to a mutation once the endpoint ships.
 */
const RowSettingsModal = ({ visible, row, onDismiss, onSave }) => {
  const [showSelfCertify, setShowSelfCertify] = useState(false);
  const [excludeFromDigest, setExcludeFromDigest] = useState(false);
  const [suppressDuplicateNotify, setSuppressDuplicateNotify] = useState(false);

  // Reset the form each time the dialog is opened for a (new) row.
  useEffect(() => {
    if (visible) {
      setShowSelfCertify(false);
      setExcludeFromDigest(false);
      setSuppressDuplicateNotify(false);
    }
  }, [visible, row]);

  const deliverableName = row?.deliverable || "";

  const handleSave = () => {
    onSave?.({
      showSelfCertify,
      excludeFromDigest,
      suppressDuplicateNotify,
    });
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={`Row Settings — ${deliverableName}`}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="l">
        <SpaceBetween size="s">
          <Header variant="h3">Options</Header>
          <Checkbox
            checked={showSelfCertify}
            onChange={({ detail }) => setShowSelfCertify(detail.checked)}
          >
            Show Self Certify
          </Checkbox>
        </SpaceBetween>

        <SpaceBetween size="s">
          <Header variant="h3">Reset</Header>
          <Box>
            <Button iconName="refresh">Reset Statuses</Button>
          </Box>
        </SpaceBetween>

        <SpaceBetween size="s">
          <Header variant="h3">Notifications</Header>
          <Checkbox
            checked={excludeFromDigest}
            onChange={({ detail }) => setExcludeFromDigest(detail.checked)}
          >
            Do not include in daily digest
          </Checkbox>
          <Checkbox
            checked={suppressDuplicateNotify}
            onChange={({ detail }) => setSuppressDuplicateNotify(detail.checked)}
          >
            Do not notify duplicate uploads
          </Checkbox>
        </SpaceBetween>
      </SpaceBetween>
    </Modal>
  );
};

export default RowSettingsModal;
